import find from 'lodash/find';
import isUndefined from 'lodash/isUndefined';
import PageData from '@Services/PageData';
import Catalyst from '@Services/Catalyst';

export const StructureEditorAnalyticsOptions = [
  // Checkboxes
  {
    name: 'tautomers',
    trackingFeatureName: 'include tautomers',
  },
  {
    name: 'stereo',
    trackingFeatureName: 'include stereo',
  },
  {
    name: 'extraRings',
    trackingFeatureName: 'include ring closures',
  },
  {
    name: 'markush',
    trackingFeatureName: 'include related markush',
  },
  {
    name: 'salts',
    trackingFeatureName: 'include salts',
  },
  {
    name: 'mixtures',
    trackingFeatureName: 'include mixtures',
  },
  {
    name: 'isotopes',
    trackingFeatureName: 'include isotopes',
  },
  {
    name: 'charges',
    trackingFeatureName: 'include charges',
  },
  {
    name: 'radicals',
    trackingFeatureName: 'include radicals',
  },
  {
    name: 'ignoreAtomMapping',
    trackingFeatureName: 'ignore atom mappings',
  },
  {
    name: 'keepFragments',
    trackingFeatureName: 'keep fragments',
  },
  // Inputs
  {
    name: 'atoms',
    trackingFeatureName: 'number of atoms',
  },
  {
    name: 'ringClosures',
    trackingFeatureName: 'number of ring closures',
  },
  {
    name: 'fragments',
    trackingFeatureName: 'number of fragments',
  },
  // Radio
  {
    name: 'searchBy',
    value: 'exact',
    trackingFeatureName: 'search as drawn',
  },
  {
    name: 'searchBy',
    value: 'similarity',
    trackingFeatureName: 'similarity search',
  },
  {
    name: 'searchBy',
    title: 'As substructure',
    trackingFeatureName: 'substructure search',
  },
  {
    name: 'searchBy_searchBy',
    value: 'substructure',
    trackingFeatureName: 'substructuresearch on all atoms',
  },
  {
    name: 'searchBy_searchBy',
    value: 'sub_hetero',
    trackingFeatureName: 'substructuresearch on heteroatoms',
  },
  {
    name: 'keepFragments',
    value: 'separate_fragments',
    trackingFeatureName: 'keep fragments separate',
  },
  {
    name: 'keepFragments',
    value: 'merge_fragments',
    trackingFeatureName: 'keep fragments together',
  },
];

function getButtonSections(feature) {
  return [Catalyst.getPrefix(), PageData.getCurrentPageName(), feature];
}

function getOptionSections(feature) {
  return [Catalyst.getPrefix(), 'structureeditor', 'feature', feature];
}

function getFeatureName(criteria) {
  const res = find(StructureEditorAnalyticsOptions, criteria);
  return res ? res.trackingFeatureName : '';
}

export function trackButton(feature) {
  const sections = getButtonSections(feature);
  Catalyst.trackProductFeature(sections.join(':'));
}

export function trackOptionRadio(name, value, title, enabled) {
  const feature = value ? getFeatureName({ name, value }) : getFeatureName({ name, title });

  if (!feature) return;

  const sections = getOptionSections(feature);

  if (!isUndefined(enabled)) {
    if (enabled) {
      sections.push('enabled');
    } else {
      sections.push('disabled');
    }
  }

  Catalyst.trackProductFeature(sections.join(':'));
}
